import React, { Component } from "react";
import { MailroomSchoolConfig } from "../../models/MailroomSchoolConfig";
import { Rule } from "../../models/mailroom-school-config-rules/Rule";
import { ConditionalConfigItem } from "./ConditonalConfigItem";
import {Dropdown, IDropdownOption, ISelectableOption} from "office-ui-fabric-react";
import {OptionWithRequirements} from "../../models/mailroom-school-config-rules/OptionWithRequirements";
import * as _ from "lodash";

export interface ConfigDropdownProps {
    label: string;
    selectedKey?: string;
    disabled?: boolean;
    onChange: (key: string) => void;
    path: string[];
    configRules: Rule[];
    config: MailroomSchoolConfig;
}

export interface ConfigDropdownState {

}

export class ConfigDropdown extends Component<ConfigDropdownProps, ConfigDropdownState> {

    constructor(props: ConfigDropdownProps) {
        super(props);

        this.state = {
        };
    }

    public async componentDidMount() {
    }

    public componentDidUpdate(prevProps: Readonly<ConfigDropdownProps>, prevState: Readonly<ConfigDropdownState>, snapshot?: any) {

    }


    private dropdownOptions(rule: Rule): IDropdownOption[] {
        return rule.options!.map(o => {
            return {
                key: o.option,
                text: o.option,
                data: o
            }
        });
    }
    
    private renderOption = (option: ISelectableOption | undefined): JSX.Element =>
    {
        if(option === undefined)
        {
            return (<div></div>);
        }

        const optionWithReqs = option.data as OptionWithRequirements<any>;

        
        const extraClasses: string[] = [];
        
        const dataServiceTypes = optionWithReqs.requirements.dataServiceTypes;
        if(dataServiceTypes != null && dataServiceTypes.length > 0)
        {
            if(!_.includes(dataServiceTypes,this.props.config.misDataServiceType))
            {
                extraClasses.push("mailroom-config-dropdown-option--unsupported");
            }
        }

        if (optionWithReqs.obsolete === true) {
            extraClasses.push("dropdown-option--red");
        }
        
        return (
            <div className={`mailroom-config-dropdown-option ${_.join(extraClasses," ")}`}>
                <span>{option.text}</span>
            </div>
        );
    }

    public render() {
        return <ConditionalConfigItem path={this.props.path} config={this.props.config} configRules={this.props.configRules} >
            {(rule) => {
                return (
                    <Dropdown
                        className={"mailroom-config-dropdown"}
                        placeholder="Select an option"
                        label={this.props.label}
                        disabled={this.props.disabled}
                        selectedKey={this.props.selectedKey}
                        options={this.dropdownOptions(rule)}
                        onRenderOption={this.renderOption}
                        onChange={(e, o) => this.props.onChange(o!.key.toString())} />
                );
            }}
        </ConditionalConfigItem>


    }
}